export default function ProductZoom () {
  return {
    restrict: 'E',
    link: (scope, element) => {
      const zoom = 200;
      let $el = $(element),
          $zd = $el.find('.zoom-display'),
          $win = $(window);

      $el.on('mouseenter', 'img.zoom:not(.smart-img-loading)', (e) => {
        if ($win.width() < 1024) return;
        let $target = $(e.currentTarget);

        $zd.addClass('show-zoom')
          .css({
            backgroundImage: `url(${$target.attr('src')})`,
            backgroundSize: `${zoom}%`,
            width: `${$target.width()}px`,
            height: `${$target.height()}px`
          });
      })
      .on('mousemove', (e) => {
        if ($win.width() < 1024) {
          $zd.removeClass('show-zoom');
          return;
        }
        let offset = $el.offset();
        let mx = e.pageX - offset.left,
            my = e.pageY - offset.top;

        $zd.css({
          backgroundPosition: `-${mx}px -${my}px`
        });
      })
      .on('mouseenter', '.owl-prev, .owl-next, .thumbnail-links, .owl-dots', () => $zd.removeClass('show-zoom'))
      .on('mouseleave', () => $zd.removeClass('show-zoom'));
    }
  }
};



// WEBPACK FOOTER //
// ./source/client/pages/store/product-zoom/product-zoom.dir.js